// JS for your graphic
import pym from "pym.js";
import * as d3 from "d3";
import d3tip from "d3-tip";

import csv from "../data/schools.csv";

function wrap(text) {
  text.each(function () {
    var text = d3.select(this),
      words = text.text().split(/\s+/).reverse(),
      word,
      line = [],
      lineHeight = 10, // ems
      y = text.attr("y"),
      dy = 0,
      tspan = text
        .text(null)
        .append("tspan")
        .attr("x", 3)
        .attr("y", y)
        .attr("dy", 10 + "px");
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(" "));
      if (
        tspan.node().getComputedTextLength() >
        text.data()[0].x1 - text.data()[0].x0 - 6
      ) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text
          .append("tspan")
          .attr("x", 3)
          .attr("y", y)
          .attr("dy", lineHeight + dy + "px")
          .text(word);
      }
    }
  });
}

let tip = d3tip()
.attr("class", "d3-tip")
.offset((d) => [d.rightSide ? 0 : -10, d.leftSide ? 10 : d.rightSide ? -10 : 0])
.direction((d) => d.rightSide ? 'w': 'n')
.html(
  (d) => `${d.school}, ${d.state}<br><br>
            Applications: ${d.apply}<br>
            Admissions: ${d.admit}<br>
            Enrollment: ${d.enroll}`
);

let tipSearch = d3tip()
.attr("class", "d3-tip")
.offset((d) => [d.rightSide ? 0 : -10, d.leftSide ? 10 : d.rightSide ? -10 : 0])
.direction((d) => d.rightSide ? 'w': 'n')
.html(
  (d) => `${d.school}, ${d.state}<br><br>
            Applications: ${d.apply}<br>
            Admissions: ${d.admit}<br>
            Enrollment: ${d.enroll}`
);

let schooldata;
let mapdata;

const draw = () => {

  let svg = d3.select("#graphic");

  const width = svg.select(function () {return this.parentNode}).node().scrollWidth;
  const height = 800;
  let counter = -1;

  svg.attr('viewBox', [0, 0, width, height]);

  d3.csv(csv).then((parsed) => {
    // step 3: draw canvas
    const preprocessed = parsed.map((v) => ({
      ...v,
      Applications: +v.Applications,
      enrolled: +v["Enrolled at UM"],
    }));

    let mich = preprocessed.filter((d) => d.State == "Michigan");
    let oos = preprocessed.filter((d) => d.State != "Michigan");

    mich.sort((a, b) => d3.descending(a.enrolled, b.enrolled));
    oos.sort((a, b) => d3.descending(a.enrolled, b.enrolled));

    schooldata = [...mich, ...oos]
    schooldata = schooldata.map((v) => v.School)
    mapdata = schooldata.map(school => school.toUpperCase());

    let hierarchy = {
      name: "feeder",
      children: [
        { name: "In-state high schools", children: mich },
        { name: "Out-of-state high schools", children: oos },
      ],
    };

    let treemap = (data) =>
      d3
        .treemap()
        .tile(d3.treemapSquarify)
        .size([width, height])
        .padding(1)
        .paddingTop(16)
        .round(true)(
        d3
          .hierarchy(data)
          .sum((d) => d.enrolled)
          .sort((a, b) => b.enrolled - a.enrolled)
      );

    const root = treemap(hierarchy);

    const leaf = svg
      .selectAll("g")
      .data(root.leaves())
      .join("g")
      .attr("class", () => `position${++counter}`)
      .attr("transform", (d) => `translate(${d.x0}, ${d.y0})`);

    const label = svg
      .selectAll("text.section-label")
      .data(root.children)
      .join("text")
      .attr("class", "section-label")
      .attr("x", d => d3.min(d.leaves().map(v => v.x0)))
      .attr("y", d => d3.min(d.leaves().map(v => v.y0)))
      .attr("dy", -4)
      .attr("dominant-baseline", "baseline")
      .text(d => d.data.name)
    
    leaf.call(tip);
    leaf.call(tipSearch)
    leaf
      .on("mousemove", function(e, d){
        highlight(d, this, width, tip);
        if(d3.select(this).nodes()[0] === d3.selectAll(`.position${last_mindex}`).nodes()[0]){
          tipSearch.hide()
        }
      })
      .on("mouseleave", function() {
        tip.hide();
        d3.select(this).select('rect')
          .attr('stroke', 'transparent')
      });

    leaf
      .append("rect")
      .attr('stroke-width', 1.75)
      .attr("fill", (d) =>
        d.data.Type.includes("Public") ? "#374567" : "#E0AE4F"
      )
      .attr("width", (d) => d.x1 - d.x0)
      .attr("fill-opacity", (d) => (d.data.enrolled > 48 ? 1 : 0.4))
      .attr("height", (d) => d.y1 - d.y0);

    leaf
      .filter((l) => l.data.enrolled > 48)
      .append("text")
      .attr("class", "school-info")
      .text((d) => `${d.data.School} (${d.data.enrolled} enrolled)`)
      .attr("fill", (d) =>
        d.data.Type.includes("Public") ? "white" : "black"
      );

    svg.selectAll("text.school-info").call(wrap);

    //set up searchbar
    d3.select('#input_field').on('keyup', onFilter).on('input', onFilter);
    d3.select('#input_button').on('click', clearField);
    d3.select("#schools").html(
      `
      ${schooldata.map((v) => `<option value="${v}">`).join("\n")}
      `
    );
  });
};

// show tooltip and border on hover/selection
function highlight (d, x, width, select_tip) {
  select_tip.show(
    {
      school: d.data.School,
      state: d.data.State,
      apply: d.data.Applications,
      admit: d.data.Admitted,
      enroll: d.data.enrolled,
      leftSide: d.x0 < width * 0.25,
      rightSide: d.x0 > width * 0.75
    },
    x
  );
  d3.select(x).select('rect')
    .attr('stroke', 'black')
}

// remove tooltip and border
function clearField(){
  document.getElementById('input_field').value = "";
  clearSearchTip();
}

function clearSearchTip(){
  tipSearch.hide()
  tip.hide()
  d3.select(d3.selectAll(`.position${last_mindex}`).nodes()[0]).select('rect')
    .attr('stroke', 'transparent')
  last_mindex !== -1
}

let last_mindex = -1;

function onFilter(){

  let filterText = d3.select('#input_field').property('value').toUpperCase();
  let mindex = mapdata.indexOf(filterText.toUpperCase());

  if ( mindex !== -1){
    last_mindex = mindex;
    d3.selectAll(`.position${mindex}`).nodes()[0].scrollIntoView({behavior: "smooth", block: 'center'})
    highlight(d3.selectAll(`.position${mindex}`).nodes()[0].__data__, d3.selectAll(`.position${mindex}`).nodes()[0], d3.select("#graphic").select(function () {return this.parentNode}).node().scrollWidth, tipSearch)
  }
  else if(last_mindex !== -1){
    clearSearchTip()
  }
}

const resize = () => {};

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  pymChild.sendHeight();
  draw();  
};
